module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-47.08d43018.png";